/** @jsxImportSource @emotion/react */
import { Divider, Grid, Typography } from '@mui/material';
import React, { useRef, useContext } from 'react';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { useTheme } from '@emotion/react';
import { useSelector } from 'react-redux';
import { Il8nContext } from '../../Helper/i18n';

function UploadPAN(props) {

    const { setUploadedPANImage, setShowUploadPAN, handleUploadPanImage, setResponseStatus, setSnackBarOpen } = props
    const panFileRef = useRef(null);
    const localeText = useContext(Il8nContext)

  
    // const [src, setSrc] = useState("")
    const theme = useTheme()
    const classes = {
        image:{
            width: '100%',
            height: '100%'
        },
        Btn:{
            marginRight: "1px",
            padding: "10px 50px",
            "&.left":{
                borderRadius: "5px 0px 0px 5px",
            },
            "&.right":{
                borderRadius: "0px 5px 5px 0px",
            }
        },
        deleteButtonDiv: {
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            backgroundColor: '#000',
            opacity: 0.7,
            top: "38px",
            zIndex: 999,
            marginTop: '-30px',
            position: 'relative',
            cursor: 'pointer'
        },
        deleteIcon: {
            marginTop: '5px',
            marginLeft: '8px'
        },
        imageBorder: {
            flexDirection: 'row',
            borderRadius: '5px',
            border:"1px dashed #C5C4C4",
            width: '100%',
            height: '180px',
            display: "flex"
        },
        imageName: {
            lineHeight: '50px',
            marginLeft: '8px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',   
            whiteSpace: "nowrap",
            padding: "0px 10px"
        },
        imageNameDiv: {
            height: '30px',
            margin: "auto",
            width: "100%",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        label: {
            alignItems: 'flex-start'
        },
        loaderDiv: {
            width: '100%',
            height: '180px',
            borderRadius: '5px',
            marginLeft: "13px"
        },
        deleteMainDiv: {
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            marginRight: '2%'
        },
        loaderHeight3: {
            height: theme.spacing(10)
        },
        loaderMargin: {
            marginBottom: theme.spacing(2.5),
            marginLeft: "8px"
        },
        loaderHeight1: {
            height: "35px"
        },
    }
    
    const handleChange = (e) => {
        let docName = panFileRef.current.files[0].name
        if (panFileRef && panFileRef.current && panFileRef.current.files[0].size / (1024 * 1024) > 5) {
            // alert("File size must be less than 5mb")
            setResponseStatus({ "message": /*"File size must be less than 5mb"*/ localeText?.kycVerificationFileSize, "type": "error" })
            setSnackBarOpen(true)
            return;
        }
        if(!(docName.includes("jpg") || docName.includes("png") || docName.includes("jpeg") || docName.includes("svg"))){
            // alert("Invalid format , please select an image of formats jpg/jpeg/png/svg")
            setResponseStatus({ "message": /*"Invalid format , please select an image of formats jpg/jpeg/png/svg"*/localeText?.kycVerificationInvalidFormat, "type": "error" })
            setSnackBarOpen(true)
            return;
        }
        const fileReader = new FileReader()
        let file = ""
        fileReader.readAsDataURL(panFileRef.current.files[0])
        fileReader.onload = (e) => {
            file = e.currentTarget.result
            // setUploadedPANImage({"fileType": file.split(",")[0].split("/")[1].split(";")[0], "base64Format": file.split(",")[1]})
            handleUploadPanImage({"fileType": file.split(",")[0].split("/")[1].split(";")[0], "base64Format": file.split(",")[1]})
        }
    }

    return (
        <Grid container css={{margin:"10px"}}>
            <Grid item xs={12} css={{marginBottom: "10px"}}>
                <Typography variant="body2">
                    {localeText?.kycVerificationQuickerApprovals}
                </Typography>
            </Grid>
            <Grid item css={{marginBottom: "10px"}}>
                <div css={classes.uploadWrapper} onClick={() => panFileRef.current.click()} >
                    <input ref={panFileRef} accept={".png, .jpg, .jpeg, .svg"} type={"file"} css={{ display: "none" }} onChange={(e) => handleChange(e)} />
                    <Grid container style={{ cursor: 'pointer', border:"1px dashed grey", borderRadius:"5px", textAlign:"center" }}>
                        <Grid item xs={12} css={classes.icon}>
                            <img css={{marginTop:"10px"}} src={"/images/Photo ID Proof.svg"} alt="Pan Upload" />
                        </Grid>
                        <Grid item xs={12} css={classes.iconText}>
                            <span style={{ color: 'black' }}>Upload Image</span>
                        </Grid>
                    </Grid>
                </div>
            </Grid>
            <Grid item xs={12} css={{marginBottom: "20px"}}>
                <Typography variant="body2" color="error" css={{cursor:"pointer", textDecoration:"underline"}} onClick={()=> setShowUploadPAN(false)}>
                    {localeText?.kycVerificationPANDetailsManually}
                </Typography>
            </Grid>
            <Grid item xs={12} css={{marginBottom: "10px"}}>
                <Divider />
            </Grid>
        </Grid>
    );
}

export default UploadPAN;